export const URL_PATH_DRILLDOWN_EXPLORATION_VIEWER = '/drilldown-exploration'
